import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.tournament,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament]?.createTournament,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		},
		rollbackAction: {
			name: 'rollbackTournamentFile',
			id: 'rollbackTournamentFile',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.tournament,
					actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].rollbackTournamentFile,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
